import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "When your brain is breaking, try XState",
  "description": "",
  "published": "2020-08-10T00:00:00.000Z",
  "redirect_from": ["/blog/when-your-brain-is-breaking-try-xstate/swizec/9473"],
  "categories": "Computer Science, Technical",
  "hero": "./img/Fdfzkov.png"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Ever built code that's like a Jenga tower of conditional logic?`}</p>
    <p>{`It always starts off easy. If A is true, show X, otherwise Y.`}</p>
    <p>{`Oh but if B is true then show Z, unless A is also true, then you need Y `}<em parentName="p">{`and`}</em>{` Z. And if C happens after A is true, but not after B is true, then you ...`}</p>
    <p>{`Aaaaand you've got a mess. A piece of code that's going to be `}<em parentName="p">{`fun`}</em>{` to maintain.`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "639px",
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/7cd8d492aef0fafc15598b40d63e0a1e/738b8/Fdfzkov.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "50.224215246636774%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'200\\'%20viewBox=\\'0%200%20400%20200\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M55%2030a70%2070%200%20002%2028c1%203%201%203%203%202%201-2%202-2%203-1%200%201%201%201%201-1%201-3%205-6%207-6h1l3-4-9-11-10-10-1%203m80%209l-7%205-6%203-3%201v6l3%203c2%200%203%203%201%205-1%201-1%201%201%203l2%203c0%201-1%201-3-1-3-3-10-6-12-6h-1c0-1-2%200-3%202l-3%202v-2c0-2-1-1-1%202v4c2%201-3%208-5%208l-1-6c0-5-1-6-2-6l-3-2-2-3-9-1-6-2h-3c-3-1-11%208-11%2013%200%206%200%208%202%2010l1%202c0%202%2014%209%2018%209l3-2c0-1%201-3%203-3l5-4c4-3%209-4%208-2v3c2%201%201%202-1%202-1%200-2%200-1%202l3%201%202-1v-2c1-3%2010%203%2010%207-1%202-1%202%202%201l4-3c1-2%202-2%202-1l1%201h3l1-3%202-3%201-3%201-1%201-1-2-1v-5c-3-4-2-5%202-12%204-5%207-15%207-22%200-4-1-4-4%200M26%20131v9l-2%202-2%208c-1%205%200%2012%202%2012l3%202c2%202%202%202-4%201-9%200-5%202%205%203l10%203%2010%202%2012%202a106%20106%200%200055-6c6%200%207-2%202-2-3%200-3%200-2-1%204-3%205-15%202-18-1%200-3%206-2%207%201%202-2%205-5%204-2%200-3%201-3%202v1l-1%201v1h-1v-9l-3%209c-2%209-3%2010-3%202%200-5%200-5-2-4-2%202-2%202-4%200s-7-2-8%200h-2l-1%202-1%201h-2c0%202-2%201-2-1-1-1-1%204-1%208%200%203-3%200-4-3-2-5-2-5-8-4-7%201-12%200-15-4-3-3-3-3-3-1-1%204%200%206%202%206l2%201h-2c-2%200-3%200-4%202h-2l1-3c2-1%201-5-1-3l-5-1c-9-2-12-9-8-14%205-5%205-11%200-16-2-3-5-4-3-1\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/7cd8d492aef0fafc15598b40d63e0a1e/ca0a1/Fdfzkov.webp 223w", "/static/7cd8d492aef0fafc15598b40d63e0a1e/75680/Fdfzkov.webp 445w", "/static/7cd8d492aef0fafc15598b40d63e0a1e/d95e5/Fdfzkov.webp 639w"],
              "sizes": "(max-width: 639px) 100vw, 639px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/7cd8d492aef0fafc15598b40d63e0a1e/e92b6/Fdfzkov.png 223w", "/static/7cd8d492aef0fafc15598b40d63e0a1e/e66bf/Fdfzkov.png 445w", "/static/7cd8d492aef0fafc15598b40d63e0a1e/738b8/Fdfzkov.png 639w"],
              "sizes": "(max-width: 639px) 100vw, 639px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/static/7cd8d492aef0fafc15598b40d63e0a1e/738b8/Fdfzkov.png",
              "alt": "Fdfzkov",
              "title": "Fdfzkov",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <p>{`This happens a lot. Sometimes fast, sometimes after months of polishing your logic to include every edge case.`}</p>
    <p>{`And that's okay. Messes happen.`}</p>
    <p>{`It's what you do with your mess that matters.`}</p>
    <p><a parentName="p" {...{
        "href": "https://twitter.com/Swizec/status/1288942710762569729"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "890px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "31.390134529147986%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'125\\'%20viewBox=\\'0%200%20400%20125\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M27%207c-6%201-7%201-11%204-5%205-8%2015-5%2017v3l2%202%201%201c-2%200%201%204%205%206%205%203%2012%203%2018%200%204-2%205-4%201-4l-4-2c-1-2%202-6%204-6h4l2-2c2%200%202%200%202-4-1-9-11-17-19-15m353%204c-2%202-2%202-5%201l-3-2v4l2%204c2%202%201%203-1%203l1%201c5%202%2010-2%2012-8%201-5-3-7-6-3\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/66616cad8953adf57d2a11e2a3a24bb2/ca0a1/techletter.app-screenshot-1597076399015.webp 223w", "/static/66616cad8953adf57d2a11e2a3a24bb2/75680/techletter.app-screenshot-1597076399015.webp 445w", "/static/66616cad8953adf57d2a11e2a3a24bb2/8d1ba/techletter.app-screenshot-1597076399015.webp 890w", "/static/66616cad8953adf57d2a11e2a3a24bb2/7f3f2/techletter.app-screenshot-1597076399015.webp 1096w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/66616cad8953adf57d2a11e2a3a24bb2/e92b6/techletter.app-screenshot-1597076399015.png 223w", "/static/66616cad8953adf57d2a11e2a3a24bb2/e66bf/techletter.app-screenshot-1597076399015.png 445w", "/static/66616cad8953adf57d2a11e2a3a24bb2/4ef49/techletter.app-screenshot-1597076399015.png 890w", "/static/66616cad8953adf57d2a11e2a3a24bb2/8ae78/techletter.app-screenshot-1597076399015.png 1096w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/66616cad8953adf57d2a11e2a3a24bb2/4ef49/techletter.app-screenshot-1597076399015.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <h2 {...{
      "id": "how-you-create-a-mess"
    }}>{`How you create a mess`}</h2>
    <p>{`Here's a mess, I made it just for you ❤️`}</p>
    <p><a parentName="p" {...{
        "href": "https://codesandbox.io/s/distracted-thunder-y85rn"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "890px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "54.26008968609865%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'217\\'%20viewBox=\\'0%200%20400%20217\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M0%20109v108h401V0H0v109m229%204v98h71v-9h96l1%205%202%204%201-98V15H229v98m2-45v5h167V63H231v5\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/88f1a9ee327d00d0ef63646e9aab0460/ca0a1/techletter.app-screenshot-1597076414013.webp 223w", "/static/88f1a9ee327d00d0ef63646e9aab0460/75680/techletter.app-screenshot-1597076414013.webp 445w", "/static/88f1a9ee327d00d0ef63646e9aab0460/8d1ba/techletter.app-screenshot-1597076414013.webp 890w", "/static/88f1a9ee327d00d0ef63646e9aab0460/3838e/techletter.app-screenshot-1597076414013.webp 1335w", "/static/88f1a9ee327d00d0ef63646e9aab0460/e11e5/techletter.app-screenshot-1597076414013.webp 1780w", "/static/88f1a9ee327d00d0ef63646e9aab0460/0a0f4/techletter.app-screenshot-1597076414013.webp 3722w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/88f1a9ee327d00d0ef63646e9aab0460/e92b6/techletter.app-screenshot-1597076414013.png 223w", "/static/88f1a9ee327d00d0ef63646e9aab0460/e66bf/techletter.app-screenshot-1597076414013.png 445w", "/static/88f1a9ee327d00d0ef63646e9aab0460/4ef49/techletter.app-screenshot-1597076414013.png 890w", "/static/88f1a9ee327d00d0ef63646e9aab0460/4e814/techletter.app-screenshot-1597076414013.png 1335w", "/static/88f1a9ee327d00d0ef63646e9aab0460/701e9/techletter.app-screenshot-1597076414013.png 1780w", "/static/88f1a9ee327d00d0ef63646e9aab0460/bb052/techletter.app-screenshot-1597076414013.png 3722w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/88f1a9ee327d00d0ef63646e9aab0460/4ef49/techletter.app-screenshot-1597076414013.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`Check the checkboxes to get different colors. Looks silly in this example and I assure you it happens all the time.`}</p>
    <p>{`Like when I was building an insurance intake form that shows fields depending on previous answers `}<em parentName="p">{`and`}</em>{` what the API says is even possible in this particular case 😅`}</p>
    <p>{`Messes happen when you're dealing with a combinatorial explosion. Every new condition `}<em parentName="p">{`doubles`}</em>{` the number of possible states.`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "800px",
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/8ce50f62e659dfeb2e05e35a38998e7e/5a190/CMAdR7S.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "74.43946188340806%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'299\\'%20viewBox=\\'0%200%20400%20299\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M51%2022L40%2038c-1%202%200%204%201%203l2-3c2-3%202-3%206-2l5%202c2%203%204%202%202-1l-1-8c-1-7-2-9-4-7m107%200l1%202c1%202-1%2022-2%2024l-17-1c-16-1-20-1-20%201l19%201c16%201%2018%201%2018%203a300%20300%200%20002%20106v-6c-2-11-4-29-3-30l-1-10c-2-14%200-51%203-61l10-1%2025-2h-34l2-8V22h-3m100%205l-3%204-2%205c-3%203-4%206-2%206l2-2c1-1%202-2%203-1l1-1c0-3%203-2%205%200%203%203%205%203%203%200v-8c-1-8-2-9-7-3m-124%204c-3%203-5%206-5%208%200%203%201%203%203-1%202-2%206-2%209%201l3%201c2%200%201-2%200-3-2%200-2-2-2-6%200-6-1-7-8%200m40-4l-1%2017c1%201%209-1%2011-3v-4c-2-3-2-3%200-4v-4l-10-2m109%203l-1%206-1%209v4h-47c0%201%2017%202%2035%202h12l-1%203-6%2065a218%20218%200%20005%2060%20354%20354%200%20014-126c0-2%202-2%2024-2l24%201c1%201-1%2013-3%2028l-6%2039a736%20736%200%20000%2049%20447%20447%200%200112-114c0-1%203-2%2019-2%2017-1%2020-1%2019-2h-11c-14%202-27%201-26-1V29l-1%2011-1%2010h-11l-24-1h-15l1-6%201-7c2-2%200-8-2-6m23%201l-1%203c1%201%200%204-1%206-1%203-1%206%201%206l1-1c0-2%200-2%203%200%206%202%2013-3%209-7l-1-2c2-3-8-7-11-5M28%2047c-6%202-5%203%200%202h26l21-1c-1-2-42-2-47-1m13%2014v2c-2%202-1%206%201%207%203%203%207%202%2011-1%205-5%203-9-6-10-6%200-6%200-6%202m87%200v8c0%202%205%203%208%201%204-2%204-8%201-9h-9m124%202c-5%206-3%209%205%209s11-5%207-10c-4-3-9-3-12%201m48-2l-1%202-3%204c-4%203-1%205%206%206%207%200%2011-2%2011-6%200-5-10-9-13-6m-130%202l-4%203c-2%201-1%205%204%206%206%202%2015-1%2015-5%200-5-10-8-15-4m176%202c-6%203-2%2010%206%2010%207%201%2012-5%208-9-3-2-10-2-14-1m-50%2023c-2%204-2%204%200%206%203%203%208%203%2012-1%206-5%204-9-5-9h-6l-1%204m-171%201c-3%202-3%205%201%208%207%203%2013%200%2013-6%200-2-1-3-4-4-5-1-6-1-10%202m124%200c-3%204-3%205%200%207l8%201c5%200%206-1%206-3%201-8-9-11-14-5m-77%2023c-7%206-5%209%206%209%206%200%206%200%207-3s1-4-1-7c-3-4-7-4-12%201m75%202c-4%205-2%207%205%209%204%200%207-1%207-6%202-6-8-9-12-3m95%202c-4%205-1%2010%208%2010%205%200%208-2%208-6%200-6-11-9-16-4m-96%2023l-1%207c0%202%2012%204%2015%202%202-2%201-8-1-9-4-2-12-2-13%200m49%2029c-2%201-6%207-6%2010%200%206%2016%206%2018%200s-7-13-12-10m47%202l-4%203c-5%203%203%2011%2010%2010%204-1%209-6%209-9%200-4-13-8-15-4m-52%2035c-5%207-4%2010%207%2010%208%200%2011-4%205-10-4-5-8-5-12%200m49%2027c-4%203-4%207-1%209%206%203%2019-1%2019-7s-13-7-18-2\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/8ce50f62e659dfeb2e05e35a38998e7e/ca0a1/CMAdR7S.webp 223w", "/static/8ce50f62e659dfeb2e05e35a38998e7e/75680/CMAdR7S.webp 445w", "/static/8ce50f62e659dfeb2e05e35a38998e7e/d00b9/CMAdR7S.webp 800w"],
              "sizes": "(max-width: 800px) 100vw, 800px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/8ce50f62e659dfeb2e05e35a38998e7e/e92b6/CMAdR7S.png 223w", "/static/8ce50f62e659dfeb2e05e35a38998e7e/e66bf/CMAdR7S.png 445w", "/static/8ce50f62e659dfeb2e05e35a38998e7e/5a190/CMAdR7S.png 800w"],
              "sizes": "(max-width: 800px) 100vw, 800px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/static/8ce50f62e659dfeb2e05e35a38998e7e/5a190/CMAdR7S.png",
              "alt": "CMAdR7S",
              "title": "CMAdR7S",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <p>{`3 variables give us 8 possible states. 4 makes 16. 5 is 32.`}</p>
    <p>{`That's booleans.`}</p>
    <p>{`Imagine enums with 4 possible states. 3 of those and you're looking at 64 combinations.`}</p>
    <p>{`🤯`}</p>
    <p>{`Your first inclination is to write chains of conditionals. Cover the 3 or 4 happy-path cases and done.`}</p>
    <p>{`The other 60 are edge cases you find in production through bug reports. You fix those.`}</p>
    <p>{`And you create long and complex conditionals that nobody on your team can read. Each bug fix creates 5 new bugs.`}</p>
    <p>{`Everything's connected, nothing makes sense.`}</p>
    <p><img parentName="p" {...{
        "src": "/15033f5c861001cb482c1553977c0476/media-l0IylOPCNkiqOgMyA-giphy.gif",
        "alt": "conspiracy_theory_board giphy"
      }}></img></p>
    <h2 {...{
      "id": "how-you-fix-the-mess-with-hashmaps"
    }}>{`How you fix the mess with hashmaps`}</h2>
    <p>{`Your way out of this mess is a stable mapping of states to values. Easiest to do with a hashmap.`}</p>
    <p>{`You can start with a truth table to get your bearings. Great for boolean logic, difficult for enums. You run out of dimensions 😅`}</p>
    <p>{`Truth table for the mess above looks like this:`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "800px",
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/c4c07b24f09eef76a46be447f59513bb/5a190/jkN5tGO.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "84.30493273542601%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'338\\'%20viewBox=\\'0%200%20400%20338\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M156%2017c-4%201-4%202-3%2014l1%2019v8h-45l1-5%201-6-2-7-1%208-1%2010-23%201H62v-5l2-8c0-4-1-7-3-6l-1%2010-1%209-22-1-21-1c-2%202%204%203%2022%203%2016%200%2021%201%2021%202l-3%2022a446%20446%200%20001%2097l1-2-3-13c-3-22-1-59%205-95l1-11h23l23%201-4%2022a388%20388%200%20006-21l23-1%2022-1v9l-8%2080a979%20979%200%2000-6%20157l1-2c-2-4-2-15%200-38l3-49a5045%205045%200%200115-156l12-1%2028-1c22-2%2053-4%2053-2a1153%201153%200%2001-14%20107l-5%2046c-5%2038-7%2075-7%2099v22l1-26a1083%201083%200%200110-120c3-31%204-44%208-63l8-59v-7h72v7l-3%2032c-2%2042-6%2081-14%20127a791%20791%200%2000-10%20106l1-5c-2-12%202-48%2010-99a1442%201442%200%200017-166v-2h42l-21-1h-20V40l1-16c2-1-1-3-2-2l-1%2017v16h-71l1-9c1-16%200-28-2-28l-1%202c2%207%202%2021%200%2032v3h-22l-31%202c-16%202-40%201-40-1%202-5%202-40%200-40l-3%201m-1%204c-1%202%200%2037%201%2037l2-4V22c0-2-3-3-3-1M39%2036l-4%206-3%206-1%203c1%201%202%201%203-1l2-1%202-1c0-2%204-1%205%201l2%201v-1l-1-8c-1-7-2-8-5-5m257%200v8c0%203%201%204%203%204%203%200%207-3%207-5%200-4-9-10-10-7m36%201l1%207c0%204%200%204%203%204%205%200%208-4%205-6v-4c0-2-1-3-5-3s-4%200-4%202M83%2042c-3%2010-3%2017%200%2013l1-1h9c2-1%203-4%201-6l-2-3c0-2-1-3-5-4l-4%201m72%2023l-8%2087a1159%201159%200%20007-57%201059%201059%200%20011-30m130%200c-4%203-4%205%200%206%204%202%208%202%2010%200%206-5-4-11-10-6m64%201c-5%205%204%2011%2010%208%203-3%203-4-1-7-3-3-7-4-9-1M33%2071c-4%204-4%207%200%208%209%203%2016-2%2010-8-4-4-6-4-10%200m43%200c0%202-1%203-2%203-2%201-3%203-1%205%203%202%2012%202%2014%200%203-2%202-7%200-8-4-3-10-3-11%200m45%202c-5%202-5%205-1%208%204%204%2014%201%2014-4%200-3-7-6-13-4m226%2018c-4%204-1%2010%205%2010%207%200%208-6%202-10-4-2-5-3-7%200M73%2094l-2%204%202%202c3%203%207%203%2011%200s4-7%200-9c-6-2-9-1-11%203m-42%201c-4%203-4%204-1%206%205%204%2013%202%2013-2%200-7-8-9-12-4m-2%2023c-5%204-4%207%202%208%205%201%208%200%209-4%201-7-6-9-11-4m247%202c-3%204-2%206%204%207%2011%201%2012-8%201-11-2%200-3%200-5%204m-159%200c-6%206%200%2012%209%209s5-11-5-11l-4%202m72%202c-3%204-4%204-2%206%207%205%2017-2%2011-7-3-3-6-2-9%201m158%200c-3%203-3%204%200%207%204%204%209%202%2011-3%201-6-7-9-11-4M27%20143c-1%205-1%206%202%207%207%202%2012%201%2012-3%200-5-2-6-8-7-6%200-6%200-6%203m158%203c-2%201-3%206-1%208%204%203%2013-1%2013-6%200-4-7-5-12-2M69%20171c-3%205-3%209%202%2010%2010%203%2017-4%2010-10-4-4-8-4-12%200m46-1l-2%202c-5%202%200%2010%206%2010s13-6%2011-10c-2-3-13-4-15-2m159%202c-6%200-9%206-6%209h12c5-3%200-10-6-9M68%20202c-6%206-3%2010%207%2010%207-1%208-2%206-7-4-7-9-7-13-3m45%2026c-5%204-3%209%205%209%205%200%2011-3%2012-7%201-5-12-7-17-2m151%204c-9%205-4%2013%206%2010%204-1%205-2%205-5%200-5-6-8-11-5m79-1c-3%205-3%207-1%209%204%204%2012%202%2012-3s-8-9-11-6m-4%2031c-4%204-3%207%202%209%208%203%2011%203%2012-3%201-3%201-4-2-6-4-4-8-4-12%200m-78-1c-3%202-4%206-3%209%204%207%2018%205%2018-3%200-6-8-9-15-6\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/c4c07b24f09eef76a46be447f59513bb/ca0a1/jkN5tGO.webp 223w", "/static/c4c07b24f09eef76a46be447f59513bb/75680/jkN5tGO.webp 445w", "/static/c4c07b24f09eef76a46be447f59513bb/d00b9/jkN5tGO.webp 800w"],
              "sizes": "(max-width: 800px) 100vw, 800px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/c4c07b24f09eef76a46be447f59513bb/e92b6/jkN5tGO.png 223w", "/static/c4c07b24f09eef76a46be447f59513bb/e66bf/jkN5tGO.png 445w", "/static/c4c07b24f09eef76a46be447f59513bb/5a190/jkN5tGO.png 800w"],
              "sizes": "(max-width: 800px) 100vw, 800px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/static/c4c07b24f09eef76a46be447f59513bb/5a190/jkN5tGO.png",
              "alt": "jkN5tGO",
              "title": "jkN5tGO",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <p>{`You can turn that into a hashmap of states. A piece of data that tells you how the code behaves.`}</p>
    <p><a parentName="p" {...{
        "href": "https://carbon.now.sh/?bg=rgba(255,255,255,1)&t=seti&l=javascript&ds=true&wc=true&wa=true&pv=48px&ph=32px&ln=false&code=const%20STATE_MAP%20%3D%20%7B%0A%20%20%220-0-0%22%3A%20%7B%20green%3A%201%2C%20red%3A%200%2C%20blue%3A%200%20%7D%2C%0A%20%20%220-0-1%22%3A%20%7B%20green%3A%201%2C%20red%3A%200%2C%20blue%3A%200%20%7D%2C%0A%20%20%220-1-0%22%3A%20%7B%20green%3A%200%2C%20red%3A%200%2C%20blue%3A%200%20%7D%2C%0A%20%20%220-1-1%22%3A%20%7B%20green%3A%200%2C%20red%3A%201%2C%20blue%3A%201%20%7D%2C%0A%20%20%221-0-0%22%3A%20%7B%20green%3A%200%2C%20red%3A%200%2C%20blue%3A%201%20%7D%2C%0A%20%20%221-0-1%22%3A%20%7B%20green%3A%201%2C%20red%3A%201%2C%20blue%3A%201%20%7D%2C%0A%20%20%221-1-0%22%3A%20%7B%20green%3A%201%2C%20red%3A%200%2C%20blue%3A%200%20%7D%2C%0A%20%20%221-1-1%22%3A%20%7B%20green%3A%201%2C%20red%3A%200%2C%20blue%3A%200%20%7D%0A%7D%3B"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "860px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "80.71748878923766%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'324\\'%20viewBox=\\'0%200%20400%20324\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M31%2046c-2%202-2%20232%200%20234s336%202%20338%200%202-232%200-234-336-2-338%200\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/9770fb48e53b18efb241b18241fdc036/ca0a1/techletter.app-screenshot-1597076399083.webp 223w", "/static/9770fb48e53b18efb241b18241fdc036/75680/techletter.app-screenshot-1597076399083.webp 445w", "/static/9770fb48e53b18efb241b18241fdc036/31b17/techletter.app-screenshot-1597076399083.webp 860w"],
                "sizes": "(max-width: 860px) 100vw, 860px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/9770fb48e53b18efb241b18241fdc036/e92b6/techletter.app-screenshot-1597076399083.png 223w", "/static/9770fb48e53b18efb241b18241fdc036/e66bf/techletter.app-screenshot-1597076399083.png 445w", "/static/9770fb48e53b18efb241b18241fdc036/914ae/techletter.app-screenshot-1597076399083.png 860w"],
                "sizes": "(max-width: 860px) 100vw, 860px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/9770fb48e53b18efb241b18241fdc036/914ae/techletter.app-screenshot-1597076399083.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`And you use it like this:`}</p>
    <p><a parentName="p" {...{
        "href": "https://carbon.now.sh/?bg=rgba(255,255,255,1)&t=seti&l=javascript&ds=true&wc=true&wa=true&pv=48px&ph=32px&ln=false&code=%20%20const%20key%20%3D%20%60%24%7BNumber(a)%7D-%24%7BNumber(b)%7D-%24%7BNumber(c)%7D%60%3B%0A%20%20const%20showGreen%20%3D%20STATE_MAP%5Bkey%5D.green%3B%0A%20%20const%20showRed%20%3D%20STATE_MAP%5Bkey%5D.red%3B%0A%20%20const%20showBlue%20%3D%20STATE_MAP%5Bkey%5D.blue%3B"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "890px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "44.39461883408072%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'177\\'%20viewBox=\\'0%200%20400%20177\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M26%2036c-2%201-2%206-2%2054l1%2053h351V90c0-48%200-53-2-54-2-2-346-2-348%200\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/8c72e8ad73d47e303e134340b357c59c/ca0a1/techletter.app-screenshot-1597076398630.webp 223w", "/static/8c72e8ad73d47e303e134340b357c59c/75680/techletter.app-screenshot-1597076398630.webp 445w", "/static/8c72e8ad73d47e303e134340b357c59c/8d1ba/techletter.app-screenshot-1597076398630.webp 890w", "/static/8c72e8ad73d47e303e134340b357c59c/dac76/techletter.app-screenshot-1597076398630.webp 1084w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/8c72e8ad73d47e303e134340b357c59c/e92b6/techletter.app-screenshot-1597076398630.png 223w", "/static/8c72e8ad73d47e303e134340b357c59c/e66bf/techletter.app-screenshot-1597076398630.png 445w", "/static/8c72e8ad73d47e303e134340b357c59c/4ef49/techletter.app-screenshot-1597076398630.png 890w", "/static/8c72e8ad73d47e303e134340b357c59c/48ca3/techletter.app-screenshot-1597076398630.png 1084w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/8c72e8ad73d47e303e134340b357c59c/4ef49/techletter.app-screenshot-1597076398630.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`😍`}</p>
    <p>{`Isn't that more readable, easier to understand, and way easier to debug? Got a problem, change the map. Done.`}</p>
    <p><a parentName="p" {...{
        "href": "https://codesandbox.io/s/eager-banach-2cxcj"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "890px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "54.26008968609865%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'217\\'%20viewBox=\\'0%200%20400%20217\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M0%20109v108h401V0H0v109m229%204v98h71v-9h96v2l1%205%202%202%201-98V15H229v98m2-45v5h167V63H231v5\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/a605cc1b3256f2f47b1954afd2a686e0/ca0a1/techletter.app-screenshot-1597076415238.webp 223w", "/static/a605cc1b3256f2f47b1954afd2a686e0/75680/techletter.app-screenshot-1597076415238.webp 445w", "/static/a605cc1b3256f2f47b1954afd2a686e0/8d1ba/techletter.app-screenshot-1597076415238.webp 890w", "/static/a605cc1b3256f2f47b1954afd2a686e0/3838e/techletter.app-screenshot-1597076415238.webp 1335w", "/static/a605cc1b3256f2f47b1954afd2a686e0/e11e5/techletter.app-screenshot-1597076415238.webp 1780w", "/static/a605cc1b3256f2f47b1954afd2a686e0/0a0f4/techletter.app-screenshot-1597076415238.webp 3722w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/a605cc1b3256f2f47b1954afd2a686e0/e92b6/techletter.app-screenshot-1597076415238.png 223w", "/static/a605cc1b3256f2f47b1954afd2a686e0/e66bf/techletter.app-screenshot-1597076415238.png 445w", "/static/a605cc1b3256f2f47b1954afd2a686e0/4ef49/techletter.app-screenshot-1597076415238.png 890w", "/static/a605cc1b3256f2f47b1954afd2a686e0/4e814/techletter.app-screenshot-1597076415238.png 1335w", "/static/a605cc1b3256f2f47b1954afd2a686e0/701e9/techletter.app-screenshot-1597076415238.png 1780w", "/static/a605cc1b3256f2f47b1954afd2a686e0/bb052/techletter.app-screenshot-1597076415238.png 3722w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/a605cc1b3256f2f47b1954afd2a686e0/4ef49/techletter.app-screenshot-1597076415238.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <h2 {...{
      "id": "how-you-fix-the-mess-with-state-machines"
    }}>{`How you fix the mess with state machines`}</h2>
    <p>{`What a hashmap can't do, is guard against impossible states. What if you don't want users to click A when B and C are true? 🤔`}</p>
    <p>{`That's when you need a `}<a parentName="p" {...{
        "href": "https://en.wikipedia.org/wiki/Finite-state_machine"
      }}>{`state machine`}</a>{`, my friend. They're fun to build, tricky to get right, and different to think about than you're used to.`}</p>
    <p><inlineCode parentName="p">{`useReducer`}</inlineCode>{` is a state machine. Redux, too. `}<inlineCode parentName="p">{`useState`}</inlineCode>{` if you squint your eyes.`}</p>
    <p>{`Here's a state machine for each of the `}<inlineCode parentName="p">{`useState`}</inlineCode>{`s in our smol mess example.`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "800px",
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/7a988a4c89765cf8dfb3a87cde9aeccc/5a190/yCtO4VE.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "76.68161434977578%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'307\\'%20viewBox=\\'0%200%20400%20307\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M94%2039c-13%205-34%2022-32%2026l-1%205c-13%2019-7%2041%2011%2047%2025%208%2069-9%2080-30%2010-18-3-38-31-46-13-4-20-5-27-2m1%203l-2%202c0%201-1%202-3%202-11%200-32%2027-33%2044-1%2016%209%2025%2031%2026%2012%200%2022-2%2037-9%2032-16%2036-41%209-57-11-7-32-11-39-8m190%200c-2%201-6%2011-5%2012%202%202%2011%202%2012%200%200-2-1-2-3-2s-2%200%200-1c3-2%203-4%200-4l-3-1%203-1c1%200%202%200%202-2-1-2-4-2-6-1m-19%202l-4%202c-1%202-1%203%206%207%202%202%202%202%201%203-2%201-3%201-5-1-3-2-5-2-5%201s10%205%2013%202c3-2%202-4-2-7-4-4-4-4-2-4%204%200%207-2%206-3h-8m-92%202l-27%203-2%202%206%201c25-3%2037-4%2050-2%2024%203%2042%2011%2056%2026%207%208%2019%2027%2023%2037l11%2023c9%2017%209%2018%205%2013-8-6-11-8-13-7-1%202-1%202%203%205l8%206%206%203%204%201c1%202%203%201%203-1%200-1%200-3%202-5l8-17c-1-2-3-1-7%209l-6%208-19-35c-19-39-35-55-61-64-13-5-35-7-50-6m-72%2022c-13%206-15%2019-4%2021%2013%203%2024-15%2014-23-2-2-5-1-10%202m7%202l-3%201c-2%200-4%201-5%203l-4%202c-1%200-2%202-2%206s6%205%2012%203c3-2%204-3%205-9%201-3-2-9-3-6m-25%2053c-6%203-13%2011-11%2013%201%202%203%200%205-3%202-6%204-4%203%204-1%2020%208%2039%2028%2056%2031%2027%2058%2041%2093%2051%2024%207%2046%206%2046-2%200-3-2-2-4%200-1%202-3%202-10%203-27%201-71-15-101-37-37-26-48-42-48-67%200-10%202-16%202-7%200%206%203%2010%205%208v-2l-1-10c0-9-1-10-7-7m209%2039c-20%204-28%208-33%2016l-7%2012c-7%2011-9%2017-9%2028-1%2038%2045%2048%2090%2018%2013-9%2019-17%2021-30%203-17-6-34-24-42-8-4-25-5-38-2m5%202l-6%202-3%202c-5%200-19%208-25%2014a48%2048%200%2000-17%2037c-1%2015%207%2025%2022%2030%2027%209%2074-12%2082-37%205-19-4-37-22-45-7-4-22-5-31-3m-1%2030l-1%206-1%2013c-1%2011-1%2012%201%2012%201%200%201%202%203-15v-16h-2M80%20234c-7%202-7%206%200%209l4%204c-1%201-7%201-8-1h-3c-1%203%201%204%207%205l7-1%207-1%206-1c0-2-1-2-4-2-4%200-3-1%201-2%205-2%205-4%201-4-2%200-3%200-2-1%201-2%205-1%207%201h2c3-3%205-1%204%203v4l1%202%202-1c0-5%202-9%205-9%201%200%202%200%202-2%200-1-2-2-9-2l-11-1c-3%200-7%201-7%203l-2%205c-1%203-1%203-3%201l-5-3-3-2%205-1%206-3H80\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/7a988a4c89765cf8dfb3a87cde9aeccc/ca0a1/yCtO4VE.webp 223w", "/static/7a988a4c89765cf8dfb3a87cde9aeccc/75680/yCtO4VE.webp 445w", "/static/7a988a4c89765cf8dfb3a87cde9aeccc/d00b9/yCtO4VE.webp 800w"],
              "sizes": "(max-width: 800px) 100vw, 800px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/7a988a4c89765cf8dfb3a87cde9aeccc/e92b6/yCtO4VE.png 223w", "/static/7a988a4c89765cf8dfb3a87cde9aeccc/e66bf/yCtO4VE.png 445w", "/static/7a988a4c89765cf8dfb3a87cde9aeccc/5a190/yCtO4VE.png 800w"],
              "sizes": "(max-width: 800px) 100vw, 800px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/static/7a988a4c89765cf8dfb3a87cde9aeccc/5a190/yCtO4VE.png",
              "alt": "yCtO4VE",
              "title": "yCtO4VE",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <p>{`Circles are states, arrows are transitions. You can draw a state machine like this for almost anything`}{`[`}{`^1].`}</p>
    <p>{`That's where `}<a parentName="p" {...{
        "href": "https://xstate.js.org/"
      }}>{`XState`}</a>{` shines – it's designed for state machines. It can even visualize them for you 😍`}</p>
    <p><a parentName="p" {...{
        "href": "https://twitter.com/Swizec/status/1289309003508408321"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "890px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "132.28699551569508%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'529\\'%20viewBox=\\'0%200%20400%20529\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M23%207C11%2011%207%2024%2013%2034c6%209%2018%2011%2026%205%204-3%204-4%200-4-2%200-3%200-2-1v-3c-1-2%200-3%205-3%203%200%204%200%204-4C47%2013%2034%203%2023%207m358%203l-2%202h-4l-4-2%203%209v1c-2%202-2%202%200%202%206%202%2011-2%2012-9%201-3%201-4-2-4-1-1-3%200-3%201m-34%2063c-2%203-1%206%201%208s9%203%208%201c-1-1%200-1%200%200%203%201%205-6%203-9-2-2-2-2-5-1h-5l-2%201M62%20160v5c-2%201%200%203%203%203l3-2%201-1c0%202%202%204%203%202h1c0%202%202%201%203-2%201-2%201-2%201%200l1%203%201-3c0-2%200-2%201%200%201%204%203%203%202-1%200-5%200-4-1-3h-2l-1-1v1l-2%201h-3l-6-1c-2-2-3-2-5-1m-32%2036c-3%202-3%202%203%207l4%206%202%201c2-1%202-1%202%205l1%205%204%201h33v-22l-18-1c-18%200-20%200-20%204%200%202-1%203-3%203-3%200-6-3-4-4s1-6-1-6c-2-1-2-1-3%201m60%204c-3%203-3%208%200%2012%202%202%203%202%2012%202%2011%200%2013-1%2016-5v-6c-3-4-5-5-15-5-9%200-10%200-13%202m143%202l-6%203-4%201h4c3%200%204%200%204%202%202%206%202%206%2042%206%2039%200%2039%200%2040-6l4-2c2%200%202%200%200-1l-6-4-3-3h-71l-4%204m-190%208l1%2010h34v-20H43v10m46%2012c-3%203-3%203-2%205%204%206%205%207%2013%207%209%200%2011-1%2013-5%201-2%202-3%204-3s2%200%200-1l-6-4c-3-3-3-3-10-3-8%200-8%200-12%204m145-1c-3%203-4%204-5%203l-3-1%202%202%204%204c2%205%204%205%2041%205h34c-2%200-1-1%201-3l2-3c0-1%201-2%203-2l4-1h-4l-3-1-2-4-3-2h-68l-3%203m-112%2012v5h-15c-14%200-15%200-17%202s-2%202-3%201v5c1%204%204%207%206%207%201%200%202%200%201%201h2l23-1c23%200%2024%200%2026-5%201-2%202-2%205-2h3l-4-1-4-2c-1-4-4-5-13-5h-9v-5l-1-4v4m98%2035l-17%201c-14%200-14%200-17%202l-2%204c0%201-1%202-4%202l-3%201h3l4%201v2c1%203%206%204%2037%204l31%201v1l2-1%204-1c4%200%209-3%209-6l4-1c2%200%203%200%201-1l-6-4-4-4h-20c-13%200-20%200-19-1h-3m-45%2011v10c0%201-1%202-4%202-2%200-3%200-2-1h-2l-23%201h-21l18%201%2018%201-8%203-7%204%2017-7%208-1c6%200%207-1%207-2l2-4v-1c-2%200-2-1-2-7l-1-7v8m43%2010l-30%201-2%202a169%20169%200%2001-3%205l2%204%202%203h-4a912%20912%200%200082-2c-2%200-2-1-1-4%200-4-4-9-9-9h-37m-87%2017c-6%203-10%206-5%204a282%20282%200%200140-2c-11%200-13%200-10-1l-21%201h-5l5-3%204-3-8%204m13%2016c-1%201-3%202-3%204-1%202-2%202-5%202l-4%201h4c4%200%204%200%205%202%202%205%204%206%2024%206s23%200%2025-5c1-2%202-3%204-3h4l-4-1-3-1-2-3-3-3h-20l-22%201m56%2014v4l-1%201v-1l-2-1c-4%202-25%202-25%201h-1l-14%201-13%201-3%203c-2%204-1%208%203%2010l3%202-3%203-2%202h2c3-1%2031-2%2034-1l1%201%201%201%202-1%206-1c5%200%205%200%202-1-4-1-2-1%206-1h10l-9-1c-12%200-9-2%205-2%2012%200%2017-2%2017-6l4-1%204-1h-4l-4-1c0-4-4-6-11-6h-7v-3c0-4-1-5-1-2m-32%2035l-3%201-5%204c-5%205-9%206-9%201-1-2-1-2-1%202l-1%207v1l1%203c1%202%201%202%201-1l1-5v-1l-1-1%202-1h4c1-1%201-1%202%201%202%206%202%206%2042%206h37v10l1%2011v-13c0-12%201-15%205-15%202-1%202-1%200-1l-3-1c0-3-4-7-7-7l-4-1h-2l-29%201-29-1-1-1-1%201m-27%2022l-50%201H43l47%201c44%200%2065%200%2056-1l-4-1h-1m12%2020l-3%204c0%202-1%202-4%202h-4l4%201c2%200%204%201%206%204l4%203h68l3-2%202-4%203-1%204-1h-4c-2%200-3-1-3-2l-2-4-3-2h-34c-33%200-35%200-37%202m-55%207l2%204c0%203%203%203%204-1l1-2v2c0%202%201%203%202%203%202%201%202%201%203-1l1-1c0%203%202%202%203%200v-2l1%202%202%202%201-2%201-2v2c0%203%202%203%202-1l1-2v2c0%203%202%204%202%202h2c2%202%203%202%204%200h2c2%203%205%201%205-3l-1-4-1%201c0%201-5%203-6%202h-4c-1%202-1%202-1%200%200-4-3-4-6-1h-1v-2l-1%201c0%201-1%202-2%201l-3%201h-1l-3-1c-1%201-2%200-2-1%200-2-2-1-2%201l-1%203-1-3c-1-2-4-3-3%200m278%2060c-4%204-1%2010%205%2010s9-6%205-11c-4-3-6-3-10%201\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/ddba12851d92415e77a146a4b409e059/ca0a1/techletter.app-screenshot-1597076399332.webp 223w", "/static/ddba12851d92415e77a146a4b409e059/75680/techletter.app-screenshot-1597076399332.webp 445w", "/static/ddba12851d92415e77a146a4b409e059/8d1ba/techletter.app-screenshot-1597076399332.webp 890w", "/static/ddba12851d92415e77a146a4b409e059/7f3f2/techletter.app-screenshot-1597076399332.webp 1096w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/ddba12851d92415e77a146a4b409e059/e92b6/techletter.app-screenshot-1597076399332.png 223w", "/static/ddba12851d92415e77a146a4b409e059/e66bf/techletter.app-screenshot-1597076399332.png 445w", "/static/ddba12851d92415e77a146a4b409e059/4ef49/techletter.app-screenshot-1597076399332.png 890w", "/static/ddba12851d92415e77a146a4b409e059/8ae78/techletter.app-screenshot-1597076399332.png 1096w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/ddba12851d92415e77a146a4b409e059/4ef49/techletter.app-screenshot-1597076399332.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`Yeah, no wonder that form broke my brain.`}</p>
    <h2 {...{
      "id": "using-xstate"
    }}>{`Using XState`}</h2>
    <p>{`Now, how do you use XState to fix the mess above?`}</p>
    <p>{`First you need to define the state machine. Flip your mindset from mapping states to transitioning between states.`}</p>
    <p>{`I like to do this in the `}<a parentName="p" {...{
        "href": "https://xstate.js.org/viz/"
      }}>{`XState visualizer`}</a>{`. Helps you see what you're doing.`}</p>
    <p><a parentName="p" {...{
        "href": "https://xstate.js.org/viz/?gist=7d8dc2133f897c61857d5509fb780658"
      }}><span parentName="a" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "776px",
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "82.95964125560539%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'332\\'%20viewBox=\\'0%200%20400%20332\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M17%2018v151l1%20150h361V18l-181-1-181%201m2%201l-1%2012v10h360v-9l-1-12c-1-2-1-2-179-2L19%2019m0%2024c-2%201-1%20272%200%20274l179%201c175%200%20178%200%20179-2l1-138V43l-180-1-179%201m73%2011c-17%201-15%200-18%203s-3%203-1%206l1%203%202-3c2-3%202-4%200-4-7-3%2032-5%2067-3%2034%201%2032%201%2034%206l2%205%202-4c2-4%205-4%2017%201l8%203-3%202-4%204c-2%204-9%204-9%201l-2-4c-1-2-2-2-19-2l-19%201v25l19%201c21%200%2021%200%2021-11v-6h4c3%200%204%200%205%203%202%204%207%206%2012%206%203-1%208-4%208-7%200-2%202-1%204%203l6%2016h-5c-3%200-4-1-6-3-3-6-12-7-18-1l-3%203-3-2c-5-2-6-1-4%204l1%203h-15c-14-1-14-1-16-4l-2-3-1%203c-1%202-3%202-12%201h-5l-5-8c-7-11-13-16-17-16l-3-1-3-4c-6-5-17-3-19%203-1%203-8%203-8%200%200-6-2-6-22-6s-20%200-20%206c0%202%200%202-2%201s-2-1-2%201l-2-1c-2-2-2-2-1-5%202-4-2-8-6-5-2%202-1%204%204%2010l5%206%202%201c2-1%202-1%202%204%200%209%200%209%2021%209s21%200%2021-10v-7h4c3%200%204%200%205%203%204%208%2018%208%2021-1%202-4%206-3%2010%202l12%2017c0%202-20%200-21-2-4-5-6-6-12-6s-8%201-11%206c-1%201-1%201-4-1l-4-1c-2%202%209%2033%2011%2034%203%202%202%203-3%203-9%201-17%204-20%207-2%202-2%202%200%205l1%203%202-3c2-3%202-4%200-4v-1c5-4%2082-4%2082%200l-1%201c-2%200-2%201%200%204l2%203%201-3c2-3%202-3%200-4v-2c1-1%2015%200%2015%201l2%204%202%204%202-3%202-4%207%202c10%203%2016%206%2013%207l-6%205c-5%204-7%204-7%201%200-6-1-6-22-6l-18%201v25h5l6%201-6%202-10%203c-5%200-5%200-10-8-8-12-12-16-16-16l-4-1c0-9-19-10-22-1%200%202-1%202-5%202s-4%200-4-4v-3l-19-1c-23%200-22-1-22%2013s-1%2013%2022%2013h19v-16h4c4%200%205%200%205%202%202%206%2013%208%2019%203l3-4%203-1c4%200%208%204%2015%2014%204%206%205%209%202%208l-10-1c-9%200-9%200-10-2-3-9-19-9-22%200l-4-1-4-1%203%2015%205%2015-8%205-11%208c-3%203-3%203-1%206l1%203%202-3c2-3%202-4%200-5-1-1-1-1%201-2h68l-20%2017c-5%204-9%204-10%201-1-4-5-6-11-6s-11%203-11%206c0%202-1%202-4%202-5%200-5%200-5-3%200-5-1-5-20-5-22%200-21%200-21%2014%200%2013%200%2013%2021%2013%2020%200%2020%200%2020-10v-7h5l4%201c0%206%2015%209%2020%204l2-4%203-1c3%200%206-2%2015-9l8-6c1%202-13%2028-17%2033-3%202-9%203-9%200l-2-4c-6-5-20-2-20%205%200%201-1%201-4-1l-5-2%204%2013c6%2022%208%2024%2017%2024%205-1%209-3%2010-7%201-1%202-2%206-2%2012%200%2036-10%2038-15%200-2%201-3%202-3v-5l-2-3-2%203c-2%204-2%205%200%205%203%200-1%204-7%208l-29%209c-5%200-5%200-6-2-3-7-15-9-20-4l-2%203-6-21c1%200%206%203%206%205%202%206%2014%208%2019%203l3-4%203-1c6%200%2011-7%2022-30%207-14%208-15%2014-14%204%200%205%201%203%202s-2%202%200%205l2%204%201-4c2-3%202-4%200-4-3-2-1-3%208-2%2010%200%2011%201%209%202-1%201-1%201%201%204l1%203%202-4c3-4%202-4%2016-1l19%207h-6c-7%200-11%201-12%206%200%203-8%203-8%200l-2-4c-1-2-2-2-19-2l-19%201-1%2013c0%2014-1%2013%2020%2013s21%200%2021-10v-7h4c3%200%204%201%206%203%203%206%2017%205%2019-1%201-3%207-3%209%201%202%205%202%2013%200%2015s-9%203-9%201c0-7-13-10-18-4l-3%204-4-1-5-2c-1%202%209%2032%2012%2035%205%204%2016%201%2018-4%201-2%202-3%204-3l5-1c1-2%203-11%203-19%200-5%200-7%204-13l20-40c1-3%202-3%206-3a1889%201889%200%200041-4l3%205c4%205%2017%204%2019-3l4-2c4%200%206-2%207-8%202-8%201-30-1-35v-8l2-41V76l-2-3c-4-4-11-7-23-10l-18-4c-9-2-19-4-33-5H92m93%203l3%201c7%200%2024%206%2031%2011%206%203%2017%2017%2024%2028l6%2010h6c6-1%2011-3%207-3-2%200-2%200%200-4%201-4%202-4%203%200%202%203%202%203%201%205l-6%207-5%206%204%207%204%207%2018-8%2019-8-3-10c-3-11-3-13%201-10l3%202%204-4c5-5%2017-4%2019%203%201%202%206%203%208%200%202-1%200-8-4-14-3-4-4-5-4-3%200%203-5%206-9%207-5%200-10-2-12-6-1-2-2-3-5-3l-3-1%203-1c3%200%204-1%205-3l5-4%203-2-7-2a389%20389%200%2000-119-8m69%2012l-1%2013%201%2012c2%202%2036%201%2038-1%203-3%203-21%200-23-2-2-36-3-38-1M45%2073l1%204v3c-2%200-1%2011%200%2012l19%201h17V70H46l-1%203m105-2v12l1%2010h37V71l-19-1-19%201m105%201v20l19%201h18V71l-19-1c-16%200-18%200-18%202M51%2077c-2%203-1%208%202%209l3-1c0-2%205-2%205%200l3%201%203-1c0-2%205-2%205%200l3%201c4-1%204-8%200-9-1%200-2%200-3%202%200%202-5%203-5%201%200-3-3-4-5-3l-1%203-2%201-3-1c0-3-4-4-5-3m105%200c-1%201-2%205-1%207s5%203%205%201l3-2c2%200%203%201%203%202l3%201%202-1%203-2%202-1-2-1-2-1c0-4-5-4-6-1-1%202-5%203-5%201s-3-4-5-3m75%2017l1%2012%208%201h7l-6-10-8-12-2-3v12m66%204l5%2017%2012-5c1-1%200-1-2-1-4%200-10-4-10-7l-2-3c-2-2-3-2-3-1M87%2099l6%2019%203-2c6-5%2017-3%2019%203%200%203%207%203%2019-1%2013-4%2012-4%209-10-4-6-5-7-17-7-10%200-11%200-11%202-1%206-14%209-19%203l-3-4-2-2c-3-2-4-2-4-1m55%204l6%2010%208-5c3-3%202-4-3-5h-11m17%204c-1%202-6%206-9%207l1%206%203%205h7l34-5c2-1-2-13-5-14l-16-2h-14l-1%203m164%201l-11%205h4c5%201%207%202%208%206%201%201%209%204%2011%203v-18l-12%204m-129-1l2%206c2%206%202%206%204%204%203-4%208-5%2014-3%205%202%205%202%2010%200%207-4%207-6-1-6h-8c-3%202-11%201-13-1-3-2-8-2-8%200m38%202v21l20-15-2-3c-3-3-3-3-10-4l-8%201m-96%2010l-14%204c-5%200-6%201-7%203l-1%204%2018-3c22-2%2020-1%2018-6-3-6-3-6-14-2m148%205l-16%207h29c10%200%2010%200%208-2l-3-7-2-4-16%206m-56-3c-1%201-2%202-5%202l-4%202c-3%209-18%208-21-1-1-2-1-2-4-2a440%20440%200%2001-35%205h-4l2%203%201%203h31l35-1h5l1-6c0-6%200-8-2-5m19%205l-6%206h9l10-1-6-12-7%207m-115%203l-28%203-9%202%2016-1h45l-1-3-4-3-19%202m194%202a1220%201220%200%2001-56%205%20109%20109%200%200162%2019c2-2%203-25%201-25l-7%201m-138%206c-7%200-6%201%202%203l12%205%205%202%207-5%208-5h-34m30%205c-8%205-9%207-6%207l4%201c2%201%203%201%207-4%206-5%208-10%205-10l-10%206m24%200c-12%205-12%206-13%209%200%205-3%208-5%208s-2%200%201%205%206%2014%206%2020v3h7c8%201%2021%200%2024-1v-1c-2%200-2-1%200-5l2-3%201%204%201%204-8%2019c0%202%200%202%207%201l36-4-3-13c-4-13-4-14%201-11l3%202%201-2c3-8%2018-8%2021%200%201%203%201%203%204%203l5%201c3%200%203-10%200-17-1-5-1-5-5-5l-4%202c-3%208-19%208-22%200%200-1-1-2-4-2l-3-1%203-1c3%200%204-1%204-2%202-4%206-6%2012-6s6-1-2-4-23-6-35-7c-11-1-15-1-12%202%202%201%202%201%200%204l-1%203-2-3c-2-3-2-4%200-4l1-2c0-3-9-1-21%204m12%208c-2%201-1%2023%200%2024l20%201c21%200%2020%201%2020-13s1-13-21-13l-19%201m-208%201l-1%2011%201%2011h37v-10l-1-12c-1-1-33-2-36%200m105%200l-1%2012%201%2010h8c8%200%209%200%2014-3%203-2%205-3%204-4%200-3-4-3-6-1s-5%202-5%200c0-1-1-2-2-1-4%200-4-2-1-3%202%200%203-2%203-2%201-3%205-2%206%200%200%203%203%203%205%200s5-2%206%201c0%203%201%203%203%201%202-1%202-2%202-6v-4l-18-1-19%201m104%200l-1%2012%201%2010h37v-22l-18-1-19%201m-37%2011c-2%203-5%205-10%205-6%200-15%209-12%2011h2c3-9%2018-9%2021%200%201%202%2010%204%2010%202%200-5-7-20-9-20l-2%202m-24%201c-3%202-4%202-4%205%200%206-1%207-12%207-8%200-9%200-13%203-7%204-6%204%2011%206%207%200%208%200%2010-3l3-4%202-2%206-4%205-5-2-2-2-3-4%202M89%20188l4%2011%203-2c4-3%2012-4%2015-1%203%201%203%201%2015-5%2018-8%2018-8%201-9-11-1-11-1-12%201-1%204-5%206-10%207-6%200-9-1-11-6l-4-4-3-2%202%2010m208-9l3%2011%203%209%202-3c4-2%2012-3%2016%200%202%201%208%200%2012-3%202-2%201-10-1-11-3-2-7-1-8%201-3%209-18%209-21%201-1-3-6-7-6-5m-147%208l-4%203%206%2011%206-15c0-2-4-2-8%201m11-2l-2%203-3%209c-3%208-3%209%201%209%202%200%2022-17%2023-20l-6-1h-13m12%2010l-9%2010%2031-4c1-1%201-2-1-7-2-7-2-8-7-8-3%200-5%201-14%209m-46-2c-9%204-12%206-12%207%200%203%205%203%2010%200l18-11c-1-3-4-2-16%204m67-6a85%2085%200%20004%2012l3-2c3-3%2011-4%2015-2%202%202%202%202%206%200%205-1%209-4%208-6h-27c-3-2-9-3-9-2m38%203l-1%206c0%205%200%205%203%204%206-1%2021-7%2024-9l4-2h-15l-15%201m-95%205c-9%206-16%209-19%209-2%200-3%201-4%203v3l37-4c0-1-3-9-6-13l-1-2-7%204m120-2l-14%206c-12%204-12%204-12%207s0%203%202%203l12-2c11%200%2010%200%2013-8%204-8%204-9-1-6m-66%2010c0%201-7%202-15%202-18%202-22%204-18%209%202%202%2020%204%2023%203l10-3%2010-2h2l-2-2-3-5c-1-2-6-3-7-2m-48%206l-49%206h21l26%201c5%200%205%200%206-3l1-5-5%201m99%200l-10%202-2%2011-1%2014v6l2%207%201%204a464%20464%200%200021-45l-11%201m-29%204l-29%205%202%201a82%2082%200%200141%2017l2-19v-6h-3l-13%202M45%20233v12l1%2010h18c21%200%2019%201%2019-13v-9l-19-1-19%201m106%200v21l19%201h18v-22l-19-1-18%201m41%2027l6%2020%201-2c5-6%2017-5%2020%203%201%203%206%203%208%200%201-2%203-20%202-21l-1%201-5%201c-2%200-3%201-4%203-4%207-18%207-21-1%200-2-6-6-6-4\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/54ce1c3422ce0a3e0d80c0225f3a106c/ca0a1/cHQdm62.webp 223w", "/static/54ce1c3422ce0a3e0d80c0225f3a106c/75680/cHQdm62.webp 445w", "/static/54ce1c3422ce0a3e0d80c0225f3a106c/bac22/cHQdm62.webp 776w"],
              "sizes": "(max-width: 776px) 100vw, 776px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/54ce1c3422ce0a3e0d80c0225f3a106c/e92b6/cHQdm62.png 223w", "/static/54ce1c3422ce0a3e0d80c0225f3a106c/e66bf/cHQdm62.png 445w", "/static/54ce1c3422ce0a3e0d80c0225f3a106c/167b5/cHQdm62.png 776w"],
              "sizes": "(max-width: 776px) 100vw, 776px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/static/54ce1c3422ce0a3e0d80c0225f3a106c/167b5/cHQdm62.png",
              "alt": "cHQdm62",
              "title": "cHQdm62",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
    `}</span></a></p>
    <p>{`👆 Click to see the full machine in XState visualizer`}</p>
    <p>{`You define XState machines by listing states, their meta data, and performable actions. Each action points to the next state.`}</p>
    <p><a parentName="p" {...{
        "href": "https://carbon.now.sh/?bg=rgba(255,255,255,1)&t=seti&l=javascript&ds=true&wc=true&wa=true&pv=48px&ph=32px&ln=false&code=const%20smolMessMachine%20%3D%20Machine(%7B%0A%20%20%20%20id%3A%20'smolMess'%2C%0A%20%20%20%20initial%3A%20'0-0-0'%2C%0A%20%20%20%20states%3A%20%7B%0A%20%20%20%20%20%20'0-0-0'%3A%20%7B%0A%20%20%20%20%20%20%20%20on%3A%20%7B%0A%20%20%20%20%20%20%20%20%20%20A%3A%20'1-0-0'%2C%0A%20%20%20%20%20%20%20%20%20%20B%3A%20'0-1-0'%2C%0A%20%20%20%20%20%20%20%20%20%20C%3A%20'0-0-1'%0A%20%20%20%20%20%20%20%20%7D%2C%0A%20%20%20%20%20%20%20%20meta%3A%20%7B%20green%3A%201%2C%20red%3A%200%2C%20blue%3A%200%20%7D%0A%20%20%20%20%20%20%7D%2C%0A%20%20%20%20%20%20'0-0-1'%3A%20%7B%0A%20%20%20%20%20%20%20%20on%3A%20%7B%0A%20%20%20%20%20%20%20%20%20%20A%3A%20'1-0-1'%2C%0A%20%20%20%20%20%20%20%20%20%20B%3A%20'0-1-1'%2C%0A%20%20%20%20%20%20%20%20%20%20C%3A%20'0-0-0'%0A%20%20%20%20%20%20%20%20%7D%2C%0A%20%20%20%20%20%20%20%20meta%3A%20%7B%20green%3A%201%2C%20red%3A%200%2C%20blue%3A%200%20%7D%0A%20%20%20%20%20%20%7D%2C"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "890px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "118.38565022421523%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'474\\'%20viewBox=\\'0%200%20400%20474\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M31%2044c-2%201-2%2011-2%20193l1%20194c1%201%2021%202%20170%202s169-1%20170-2l1-194c0-189%200-192-2-193H31\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/9558d26cd063eb47f71b4e908d7bc8b3/ca0a1/techletter.app-screenshot-1597076398823.webp 223w", "/static/9558d26cd063eb47f71b4e908d7bc8b3/75680/techletter.app-screenshot-1597076398823.webp 445w", "/static/9558d26cd063eb47f71b4e908d7bc8b3/8d1ba/techletter.app-screenshot-1597076398823.webp 890w", "/static/9558d26cd063eb47f71b4e908d7bc8b3/7aa27/techletter.app-screenshot-1597076398823.webp 892w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/9558d26cd063eb47f71b4e908d7bc8b3/e92b6/techletter.app-screenshot-1597076398823.png 223w", "/static/9558d26cd063eb47f71b4e908d7bc8b3/e66bf/techletter.app-screenshot-1597076398823.png 445w", "/static/9558d26cd063eb47f71b4e908d7bc8b3/4ef49/techletter.app-screenshot-1597076398823.png 890w", "/static/9558d26cd063eb47f71b4e908d7bc8b3/1568e/techletter.app-screenshot-1597076398823.png 892w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/9558d26cd063eb47f71b4e908d7bc8b3/4ef49/techletter.app-screenshot-1597076398823.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`This looks like a lot of work compared to a hashmap, I know, but it's invaluable when you want to prevent some transitions. Or you need to run side-effects when states are entered/exited.`}</p>
    <p>{`XState can do all that, it's great.`}</p>
    <p>{`Putting this in our smol mess, you get this:`}</p>
    <p><a parentName="p" {...{
        "href": "https://codesandbox.io/s/blissful-sound-k13mu"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "890px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "54.26008968609865%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'217\\'%20viewBox=\\'0%200%20400%20217\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M0%20109v108h401V0H0v109m229%204v98h71v-9h96l1%205%202%204%201-98V15H229v98m2-45v5h167V63H231v5\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/71a7197712e71252977acaa82fc28051/ca0a1/techletter.app-screenshot-1597076415032.webp 223w", "/static/71a7197712e71252977acaa82fc28051/75680/techletter.app-screenshot-1597076415032.webp 445w", "/static/71a7197712e71252977acaa82fc28051/8d1ba/techletter.app-screenshot-1597076415032.webp 890w", "/static/71a7197712e71252977acaa82fc28051/3838e/techletter.app-screenshot-1597076415032.webp 1335w", "/static/71a7197712e71252977acaa82fc28051/e11e5/techletter.app-screenshot-1597076415032.webp 1780w", "/static/71a7197712e71252977acaa82fc28051/0a0f4/techletter.app-screenshot-1597076415032.webp 3722w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/71a7197712e71252977acaa82fc28051/e92b6/techletter.app-screenshot-1597076415032.png 223w", "/static/71a7197712e71252977acaa82fc28051/e66bf/techletter.app-screenshot-1597076415032.png 445w", "/static/71a7197712e71252977acaa82fc28051/4ef49/techletter.app-screenshot-1597076415032.png 890w", "/static/71a7197712e71252977acaa82fc28051/4e814/techletter.app-screenshot-1597076415032.png 1335w", "/static/71a7197712e71252977acaa82fc28051/701e9/techletter.app-screenshot-1597076415032.png 1780w", "/static/71a7197712e71252977acaa82fc28051/bb052/techletter.app-screenshot-1597076415032.png 3722w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/71a7197712e71252977acaa82fc28051/4ef49/techletter.app-screenshot-1597076415032.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p><a parentName="p" {...{
        "href": "https://carbon.now.sh/?bg=rgba(255,255,255,1)&t=seti&l=javascript&ds=true&wc=true&wa=true&pv=48px&ph=32px&ln=false&code=const%20%5Bstate%2C%20send%5D%20%3D%20useMachine(smolMessMachine)%3B"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "890px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "37.21973094170403%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'148\\'%20viewBox=\\'0%200%20400%20148\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M27%2040c-2%202-3%2067-1%2070%203%203%20345%203%20348%200%202-3%201-68-1-70-2-3-344-3-346%200\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/1d325f1f4fd1e11a82c4bacb086586ae/ca0a1/techletter.app-screenshot-1597076398665.webp 223w", "/static/1d325f1f4fd1e11a82c4bacb086586ae/75680/techletter.app-screenshot-1597076398665.webp 445w", "/static/1d325f1f4fd1e11a82c4bacb086586ae/8d1ba/techletter.app-screenshot-1597076398665.webp 890w", "/static/1d325f1f4fd1e11a82c4bacb086586ae/22cc9/techletter.app-screenshot-1597076398665.webp 1004w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/1d325f1f4fd1e11a82c4bacb086586ae/e92b6/techletter.app-screenshot-1597076398665.png 223w", "/static/1d325f1f4fd1e11a82c4bacb086586ae/e66bf/techletter.app-screenshot-1597076398665.png 445w", "/static/1d325f1f4fd1e11a82c4bacb086586ae/4ef49/techletter.app-screenshot-1597076398665.png 890w", "/static/1d325f1f4fd1e11a82c4bacb086586ae/73b94/techletter.app-screenshot-1597076398665.png 1004w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/1d325f1f4fd1e11a82c4bacb086586ae/4ef49/techletter.app-screenshot-1597076398665.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`Hooks the machine up to your component. `}<inlineCode parentName="p">{`state`}</inlineCode>{` is the current state machine state, `}<inlineCode parentName="p">{`send`}</inlineCode>{` is like dispatch – sends actions.`}</p>
    <p>{`Checkboxes use `}<inlineCode parentName="p">{`send`}</inlineCode>{` instead of `}<inlineCode parentName="p">{`setX`}</inlineCode></p>
    <p><a parentName="p" {...{
        "href": "https://carbon.now.sh/?bg=rgba(255,255,255,1)&t=seti&l=javascript&ds=true&wc=true&wa=true&pv=48px&ph=32px&ln=false&code=%3Clabel%3E%0A%20%20%3Cinput%20type%3D%22checkbox%22%20checked%3D%7Ba%7D%20onChange%3D%7B()%20%3D%3E%20send(%22A%22)%7D%20%2F%3EA%0A%3C%2Flabel%3E"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "890px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "34.97757847533632%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'139\\'%20viewBox=\\'0%200%20400%20139\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M21%2031c-1%202-2%2078%200%2078l358%201c2-1%201-77%200-79-2-2-356-2-358%200\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/96ad5d448462696ad76200b45e13476d/ca0a1/techletter.app-screenshot-1597076398398.webp 223w", "/static/96ad5d448462696ad76200b45e13476d/75680/techletter.app-screenshot-1597076398398.webp 445w", "/static/96ad5d448462696ad76200b45e13476d/8d1ba/techletter.app-screenshot-1597076398398.webp 890w", "/static/96ad5d448462696ad76200b45e13476d/63399/techletter.app-screenshot-1597076398398.webp 1276w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/96ad5d448462696ad76200b45e13476d/e92b6/techletter.app-screenshot-1597076398398.png 223w", "/static/96ad5d448462696ad76200b45e13476d/e66bf/techletter.app-screenshot-1597076398398.png 445w", "/static/96ad5d448462696ad76200b45e13476d/4ef49/techletter.app-screenshot-1597076398398.png 890w", "/static/96ad5d448462696ad76200b45e13476d/0d98f/techletter.app-screenshot-1597076398398.png 1276w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/96ad5d448462696ad76200b45e13476d/4ef49/techletter.app-screenshot-1597076398398.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`And you read current state like this:`}</p>
    <p><a parentName="p" {...{
        "href": "https://carbon.now.sh/?bg=rgba(255,255,255,1)&t=seti&l=javascript&ds=true&wc=true&wa=true&pv=48px&ph=32px&ln=false&code=%2F%2F%200-0-0%20%F0%9F%91%89%20%5Bfalse%2C%20false%2C%20false%5D%0Aconst%20%5Ba%2C%20b%2C%20c%5D%20%3D%20state.value.split(%22-%22).map(Number).map(Boolean)%3B%0A%0Aconst%20showGreen%20%3D%20!!state.meta%5B%60smolMess.%24%7Bstate.value%7D%60%5D.green%2C%0AshowRed%20%3D%20!!state.meta%5B%60smolMess.%24%7Bstate.value%7D%60%5D.red%2C%0AshowBlue%20%3D%20!!state.meta%5B%60smolMess.%24%7Bstate.value%7D%60%5D.blue%3B"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "890px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "43.946188340807176%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'175\\'%20viewBox=\\'0%200%20400%20175\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M22%2032c-2%202-3%20111-1%20113s356%202%20358%200%201-111-1-113c-2-3-354-3-356%200\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/2d38024f471c630c0833df8a591db54c/ca0a1/techletter.app-screenshot-1597076399080.webp 223w", "/static/2d38024f471c630c0833df8a591db54c/75680/techletter.app-screenshot-1597076399080.webp 445w", "/static/2d38024f471c630c0833df8a591db54c/8d1ba/techletter.app-screenshot-1597076399080.webp 890w", "/static/2d38024f471c630c0833df8a591db54c/4ef06/techletter.app-screenshot-1597076399080.webp 1260w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/2d38024f471c630c0833df8a591db54c/e92b6/techletter.app-screenshot-1597076399080.png 223w", "/static/2d38024f471c630c0833df8a591db54c/e66bf/techletter.app-screenshot-1597076399080.png 445w", "/static/2d38024f471c630c0833df8a591db54c/4ef49/techletter.app-screenshot-1597076399080.png 890w", "/static/2d38024f471c630c0833df8a591db54c/78612/techletter.app-screenshot-1597076399080.png 1260w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/2d38024f471c630c0833df8a591db54c/4ef49/techletter.app-screenshot-1597076399080.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`Your code would have better-named states than my example. No need to translate with .map :)`}</p>
    <p>{`The meta data nests under your state machine name because you can have multiple running in parallel. That's when XState becomes pure wow 😉`}</p>
    <p>{`And unless I made a mistake, all 3 codesandboxes should behave the same. But 2 of those are way easier to debug ✌️`}</p>
    <p>{`Happy hacking`}</p>
    <p>{`Cheers,`}<br parentName="p"></br>{`
`}{`~Swizec`}</p>
    <p>{`[`}{`^1] finite state machines can't solve every solvable problem. `}<a parentName="p" {...{
        "href": "https://en.wikipedia.org/wiki/Pushdown_automaton"
      }}>{`Pushdown automata`}</a>{` (state machines with a stack) are more powerful and `}<a parentName="p" {...{
        "href": "https://en.wikipedia.org/wiki/Turing_machine"
      }}>{`Turing machines`}</a>{` (state machine with an infinite memory) can solve anything`}</p>
    <p>{`PS: you can use XState in server code, too`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      